export function generateId(serieSettingsId: string, serieId: string) {
  return `${serieSettingsId}:${serieId}`
}
